import React, { useState } from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Tooltip } from '@mui/material';
import { ToolbarButton } from '@mui/x-data-grid-premium';
import moment from 'moment/moment';

import { DefaultToolbar } from 'components/MUIDataGrid/DefaultToolbar/DefaultToolbar';
import { exceljsPostProcess } from 'components/pages/patient-source/PmWorkbook/PMWorkbookServices';

import { CustomViews } from './CustomViews/CustomViews';

export const PMWorkbookToolbar = ({
  defaultTableState,
  dateFieldFormats,
  columnGroupingModel,
  columns,
  tableVersion,
  tableName,
  refreshData,
  ...restProps
}) => {
  const [quickFilterExpanded, setQuickFilterExpanded] = useState(false);

  return (
    <DefaultToolbar
      {...restProps}
      data-testid="pm-workbook-table-toolbar"
      quickFilterProps={{ expanded: quickFilterExpanded, onExpandedChange: setQuickFilterExpanded }}
      printOptions={{ disableToolbarButton: true }}
      csvOptions={{
        disableToolbarButton: true
      }}
      excelOptions={{
        fileName: `PM_Worklist_${moment().format('MM-DD-YYYY_HH-mm-ss')}`,
        columnsStyles: dateFieldFormats,
        exceljsPreProcess: ({ worksheet }) => {
          worksheet.dataValidations.model = [];
        },
        exceljsPostProcess: exceljsPostProcess
      }}
    >
      <Tooltip title="Refresh">
        <ToolbarButton onClick={refreshData} data-testid="refresh-table-button">
          <RefreshIcon fontSize="small" />
        </ToolbarButton>
      </Tooltip>
      <CustomViews
        defaultTableState={defaultTableState}
        columnGroupingModel={columnGroupingModel}
        columns={columns}
        tableVersion={tableVersion}
        tableName={tableName}
        setQuickFilterExpanded={setQuickFilterExpanded}
      />
    </DefaultToolbar>
  );
};
